/* al-catalogo.js — Arte Líquida, zona catálogo. Sem dependências.
   1. Barra de compra fixa na página de produto (telemóvel).
   2. Revelação dos cartões quando a grelha é substituída por filtros/ordenação.
      A revelação inicial (.al-rv + .on) é de al-chrome.js; aqui só tratamos dos
      cartões novos que o Section Rendering injeta depois. */
(function () {
  'use strict';

  /* ── 1. Barra de compra ── */
  var ocupado = false;

  function botaoCompra() {
    return document.querySelector('product-info .product-form__submit');
  }

  function atualizarBarra() {
    ocupado = false;
    var barra = document.querySelector('[data-al-barra]');
    var botao = botaoCompra();
    if (!barra || !botao) return;

    var fora = botao.getBoundingClientRect().bottom < 0;
    barra.classList.toggle('on', fora);
    barra.setAttribute('aria-hidden', fora ? 'false' : 'true');

    var acao = barra.querySelector('[data-al-barra-comprar]');
    if (acao) {
      acao.tabIndex = fora ? 0 : -1;
      acao.disabled = botao.disabled;
    }

    var preco = barra.querySelector('[data-al-barra-preco]');
    var raiz = document.querySelector('product-info [id^="price-"]');
    if (preco && raiz) {
      var item = raiz.querySelector('.price--on-sale .price-item--sale') || raiz.querySelector('.price-item--regular');
      if (item && item.textContent.trim()) preco.textContent = item.textContent.trim();
    }
  }

  function agendar() {
    if (ocupado) return;
    ocupado = true;
    window.requestAnimationFrame(atualizarBarra);
  }

  window.addEventListener('scroll', agendar, { passive: true });
  window.addEventListener('resize', agendar);
  document.addEventListener('shopify:section:load', agendar);

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest ? e.target.closest('[data-al-barra-comprar]') : null;
    if (!alvo) return;
    var botao = botaoCompra();
    if (botao && !botao.disabled) botao.click();
  });

  /* ── 2. Cartões novos depois de filtrar ou ordenar ── */
  function revelarNovos(mutacoes) {
    var novos = [];
    mutacoes.forEach(function (m) {
      m.addedNodes.forEach(function (no) {
        if (no.nodeType !== 1) return;
        if (no.classList.contains('al-rv')) novos.push(no);
        no.querySelectorAll('.al-rv:not(.on)').forEach(function (el) { novos.push(el); });
      });
    });
    if (!novos.length) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        novos.forEach(function (el) { el.classList.add('on'); });
      });
    });
  }

  function observarGrelha() {
    var contentor = document.getElementById('ProductGridContainer');
    if (!contentor || contentor.__alObs) return;
    contentor.__alObs = new MutationObserver(revelarNovos);
    contentor.__alObs.observe(contentor, { childList: true, subtree: true });
  }

  observarGrelha();
  document.addEventListener('DOMContentLoaded', function () { observarGrelha(); agendar(); });
  document.addEventListener('shopify:section:load', observarGrelha);
})();

/* Slider de preço: arrastar escreve nos campos «De / Até» do <price-range> que está mesmo antes,
   e o evento «input» chega ao formulário de filtros, que atualiza a grelha (com o atraso do Dawn). */
document.addEventListener('input', (e) => {
  const r = e.target.closest && e.target.closest('.al-preco__range');
  if (!r) return;
  const box = r.closest('.al-preco');
  const [rMin, rMax] = box.querySelectorAll('.al-preco__range');
  if (+rMin.value > +rMax.value) {
    if (r === rMin) rMin.value = rMax.value; else rMax.value = rMin.value;
  }
  const max = +rMax.max || 1;
  box.style.setProperty('--a', (rMin.value / max) * 100 + '%');
  box.style.setProperty('--b', (rMax.value / max) * 100 + '%');
  box.querySelector('[data-al-de]').textContent = rMin.value + ' €';
  box.querySelector('[data-al-ate]').textContent = rMax.value + ' €';
  const pr = box.previousElementSibling;
  if (!pr || pr.tagName !== 'PRICE-RANGE') return;
  const [iMin, iMax] = pr.querySelectorAll('input');
  iMin.value = +rMin.value > 0 ? rMin.value : '';
  iMax.value = +rMax.value < max ? rMax.value : '';
});
